// RESUME SEARCH ALERTS ***************************************************************************
// pathname: /v2/resume-search-alerts
// ************************************************************************************************
import { useSwrApi, ApiResumeSearchAlert } from 'src/hooks/useSwrApi';


/**
 * @description SWR: fetch resume search alerts.
 * @param locale - string, the locale. Default 'ro'.
 * @param shouldFetch - boolean, if true, the data will be fetched. Default true.
 * @param serverData - ApiResumeSearchAlert[]. The server data to use for the request.
 */
export const useSwrResumeSearchAlerts = (
  locale: string = 'ro',
  shouldFetch: boolean = true,
  serverData?: ApiResumeSearchAlert[],
) => {
  // SWR: fetch data
  const {
    data, error, isLoading, isValidating, mutate,
  } = useSwrApi<ApiResumeSearchAlert[]>({
    url: '/v2/resume-search-alerts',
    locale,
    serverSideData: serverData,
    shouldFetch,
    apiOptions: {
      revalidateOnFocus: false,
      dedupingInterval: 60 * 1000, // 1 minute
      keepPreviousData: true,
    },
  });

  // Return data
  return {
    data,
    error,
    mutate,
    isLoading,
    isValidating,
  };
};
